import React from "react";
import GridHeader from "./Grid/GridHeader";
import { Alert, Container } from "reactstrap";
import GridBody from "./Grid/GridBody";
import withRouter from "../../../components/Common/withRouter";
import { DF_CO0008Context } from "./context";

function DF_CO0008(props) {
  document.title = "Defender | Download de Arquivo";

  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);

  if (!parseParams.get("ID_Arquivo")) {
    return (
      <Alert color="danger">
        Não é possível acessar essa transação sem parametros
      </Alert>
    );
  }

  return (
    <DF_CO0008Context.Provider value={{ parseParams }}>
      <div className="page-content">
        <Container fluid={true}>
          <GridHeader />
          <GridBody />
        </Container>
      </div>
    </DF_CO0008Context.Provider>
  );
}

export default withRouter(DF_CO0008);